






























import { Component, Prop, Vue } from 'vue-property-decorator';

/**
 * @author guan
 * @description 能效分析结果
 */
@Component({
    components: {},
})
export default class Card extends Vue {
    /**传入的data */
    @Prop({
        default: () => {
            return [0, 0, 0, 0];
        },
    })
    data!: number[];
    /**初始标题 */
    @Prop({ default: () => 2018 })
    title!: string;
    /** 年份指针 */
    @Prop({ default: 0 })
    yearIndex!: number;
}
